import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAppNavigator } from '../services/navigationService';

/**
 * Publishes the router's navigate function to navigationService so non-React
 * modules (the toast layer, notificationService) can SPA-navigate instead of
 * doing a full-page reload. Renders nothing. Must live inside <Router>.
 */
const NavigationRegistrar: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setAppNavigator(navigate);
    return () => setAppNavigator(null);
  }, [navigate]);

  return null;
};

export default NavigationRegistrar;
